module.exports = __webpack_public_path__ + "9e82a4fb.svg";